import './autocomplete.sass';
import BasicInput from '../../basic-input/src/basic-input';
import axios from 'axios';

export default {
	props: {
		value: {
			required: false
		},
		needValidation: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			inputData: {
				city: null,
				region: null
			},
			timer: false,
			suggestions: [],
			location: '',
			focused: false,
			hasError: false,
			manualError: '',
		};
	},

	template: `
		<div class="autocomplete" :class="{focused}">
			<BasicInput
				:disabled="true"
				title="Область/регион"
				:value="inputData.region"
			/>
			<div class="select">
				<BasicInput
					title="Город/нас.пункт"
					v-model="inputData.city"
					:manualError="manualError"
					@focus="focused = true"
					@blur="changeFocus()"
					@input="search"
				/>
				<ul
					v-if="!timer && suggestions.length > 0"
					class="autocomplete__dropdown"
				>
					<li
						class="autocomplete__item"
						v-for="(item, index) in suggestions"
						:key="index"
						@click="chooseLocation(item)"
					>
						<span class="autocomplete__item-text">{{ item.value }}</span>
					</li>
				</ul>
			</div>
		</div>
	`,

	methods: {
		search() {
			this.inputData.region = null
			if(this.timer || this.inputData.city.length < 2) {
				this.suggestions = [];
				return;
			}
			this.timer = setTimeout(() => {
				let requestData = {
					app: 'dadataHints',
					data: {
						request: this.inputData.city
					}
				};
				axios.post('/rest/', requestData)
					.then((response) => {
						this.suggestions = response.data.result.suggestions;
					});
				this.timer = false;
			}, 500);
		},

		chooseLocation(location) {
			if(location.data.settlement_with_type) {
				this.inputData.city = location.data.settlement_with_type;
				location.data.city_with_type = location.data.settlement_with_type;
			} else {
				this.inputData.city = location.data.city_with_type;
			}
			this.inputData.region = location.data.region_with_type;
			this.hasError = false;
			this.suggestions = [];
			this.$emit('selected-city', location);
		},

		checkIfTarget(e) {
			if(!e.target.closest('.autocomplete')) {
				this.suggestions = [];
			}
		},
		changeFocus() {
			this.focused = false;
			if (!this.inputData.region && this.needValidation) {
				this.hasError = true;
				this.manualError = 'Необходимо указать город';
			}
		}
	},

	created() {
		if(this.value && this.value.city) {
			this.inputData = this.value;
		}
	},

	watch: {
		inputData: {
			deep: true,
			handler(value) {
				if (this.manualError) {
					this.manualError = '';
					this.hasError = false;
				}
				if (!value.city && this.needValidation) {
					this.hasError = true;
					this.manualError = 'Необходимо указать город';
					this.$emit('selected-city', { data: {
						city_with_type: '',
						region_with_type: ''
					} });
				}
			}
		}
	},

	mounted() {
		this.hasError = this.needValidation && this.value ? !this.value.city : false;
		document.addEventListener('click', this.checkIfTarget);
	},

	beforeDestroy() {
		document.removeEventListener('click', this.checkIfTarget);
	},

	components: {
		BasicInput: BasicInput
	}
};
